<template>
  <div>
    <v-head :title="title"></v-head>
    <div class="content">
        <div class="titleCont"><h1>{{notice.title}}</h1></div>
            <div class="nameCont"><span>来源：{{getBranchName(notice.branchCode)}}</span> <span>发布时间：{{notice.releaseTime | limitDate}} </span></div>
            <div class="contentT" v-html="notice.content"></div>
        </div>
  </div>
</template>

<script type="text/javascript">
import {
    getNotice,
    getBranchs
} from "@/api/dictionary";
import vHead from "../../../components/Subhead";
import {getSessionStore} from "@/utils/sessionStorage.js"
import {mapState} from "vuex";

export default {
  data() {
    return {
        notice:{},
        branchs:[],
        title:"详情"
    };
  },
  components: {
    vHead
  },
    computed: {
        noticeId() {
            return this.$route.query&&this.$route.query.noticeId;
        },
        getBranchName() {
            return code => {
                let branch = this.branchs.filter(branch => branch.code == code);
                if (branch.length > 0) {
                    return branch[0].name;
                }
            }
        }
    },
  methods: {
   go(pathName) {
      this.$router.push({ name: pathName });
    },
    getData(){
        getNotice({noticeId:this.noticeId}).then(res=>{
            if(res.success){
                this.notice = res.result;
                if(this.notice.content){
                    let reg = new RegExp(/style\s*?=\s*?([‘"])[\s\S]*?\1/, "g");
                    this.notice.content = this.notice.content.replace(reg,"");
                }
            }else {
                this.$message.error(res.message);
            }
        })
    },
    getBranchs(){
        getBranchs().then(res=>{
            if(res.success){
                this.branchs = res.result;
            }else {
                this.$message.error(res.message);
            }
        });
    },
    intercept(item){
       
    
    if(item){
        let content = item.replace(reg,"");
         console.log(content)
        return content;
    } 
    },
  },
  mounted() {
      this.getBranchs();
      this.getData();
  }
};
</script>

<style scoped lang="less">
.breadcrumb-box{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 94%;
    padding-left:3%;
    height: 76px;
    margin: 0 auto;
    font-size: 14px !important;
    line-height: 76px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;}
.breadcrumb-box img{
    width: 13px;
    height: 16px;
    margin-right: 10px;
}
.breadcrumb-box span{ margin:0 4.5px; font-size: 14px;}
.content{ width: 94%; padding:0 3%;}
.titleCont{ margin-top: 25px;}
.titleCont h1{ font-size: 22px; font-weight: bold; text-align: left; color:#333; }
.nameCont{ text-align: left; font-size:14px; margin-top: 20px; }
.nameCont span{ margin: 15px 10px 15px 0; font-size:12px; }
.contentT{ margin-top: 20px;line-height: 24px;font-size: 15px; }
.contentT p{ margin-bottom: 15px; font-size: 15px; line-height: 24px; }

</style>